module.exports = __webpack_public_path__ + "static/media/dummyImg.44d7319c.png";